import { useTranslation } from 'next-i18next'

import { StackNLoadProductIslandStat } from '~/statistics/types/stack-n-load.types'
import SVGImage from '~/components/Image/SVGImage'

import LevelInfo from '../LevelInfo'

import StackNLoadLevel from './StackNLoadLevel'

interface Props {
  island: StackNLoadProductIslandStat
  islandNo: number
  lastIsland: boolean
}

export default function StackNLoadIsland({ island, islandNo, lastIsland }: Props): React.ReactElement {
  const { title, levels, totalLevelsCount, totalGoldBoxesCount, collectedGoldBoxesCount } = island
  const { t } = useTranslation('games')

  const renderGoldBoxes = totalGoldBoxesCount ? (
    <div className="flex">
      <SVGImage alt={t('cranegame.goldBox')} className="mr-2" srcKey="scoreboard/gold-box-sm.svg" />
      <p className="font-medium">
        {collectedGoldBoxesCount}/{totalGoldBoxesCount}
      </p>
    </div>
  ) : null

  return (
    <div>
      <LevelInfo addon={renderGoldBoxes} levelNo={islandNo} name={title} />
      <div className="py-1">
        {[...Array(totalLevelsCount)].map((_, index) => {
          const levelNo = index + 1
          const levelDetails = levels[levelNo]

          return (
            <StackNLoadLevel
              key={levelNo}
              levelNo={levelNo}
              locked={levelDetails.locked}
              score={levelDetails?.score ?? 0}
              stars={levelDetails?.stars ?? 0}
            />
          )
        })}
      </div>
      {!lastIsland && <div className="mt-1 mb-3 w-full h-0.5 bg-purple-light" />}
    </div>
  )
}
